"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalibratedToWorld = CalibratedToWorld;
exports.WorldToCalibrated = WorldToCalibrated;
exports.CalibratedToImage = CalibratedToImage;
exports.ImageToCalibrated = ImageToCalibrated;
exports.MeasureToWorld = MeasureToWorld;
exports.WorldToMeasure = WorldToMeasure;
exports.MeasureToCalibrated = MeasureToCalibrated;
const tslib_1 = require("tslib");
const vector_1 = require("./../vector");
const GeoUtil = tslib_1.__importStar(require("./geometry.util"));
// Calibrated < -- > World
function CalibratedToWorld(focalLength, planeCenter_MRW, planeNormal_MRW, resolution, point_CI) {
    let line = {
        start: new vector_1.Vector(),
        end: CalibratedToImage(resolution, point_CI),
    };
    line.end.z = focalLength;
    return GeoUtil.linePlaneIntersection(line, planeCenter_MRW, planeNormal_MRW);
}
function WorldToCalibrated(focalLength, resolution, point_MRW) {
    let point_IP = new vector_1.Vector();
    let pz = point_MRW.z;
    point_IP.x = (point_MRW.x * focalLength) / pz;
    point_IP.y = (point_MRW.y * focalLength) / pz;
    return ImageToCalibrated(resolution, point_IP);
}
// Calibrated < -- > Image
function CalibratedToImage(resolution, point_CI) {
    return new vector_1.Vector(point_CI.x - resolution.width / 2, point_CI.y - resolution.height / 2);
}
function ImageToCalibrated(resolution, point_IP) {
    return new vector_1.Vector(point_IP.x + resolution.width / 2, point_IP.y + resolution.height / 2);
}
// Measure < -- > World
function MeasureToWorld(planeOrigin_MRW, planeAxis_MP, point_MP) {
    let point_MRW = planeOrigin_MRW;
    point_MRW = point_MRW.add(planeAxis_MP.x.multiply(point_MP.x));
    point_MRW = point_MRW.add(planeAxis_MP.y.multiply(point_MP.y));
    return point_MRW;
}
function WorldToMeasure() {
    throw new Error('Not Yet Implemented!');
}
// Measure < -- > Calibrated
function MeasureToCalibrated(focalLength, planeOrigin_MRW, planeAxis_MP, resolution, point_MP) {
    let point_MRW = MeasureToWorld(planeOrigin_MRW, planeAxis_MP, point_MP);
    return WorldToCalibrated(focalLength, resolution, point_MRW);
}
//# sourceMappingURL=coordinate.projection.js.map